import {Box, Container, Typography} from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import React, {useCallback} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {HomeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {MainHeader} from 'presentation/components/MainHeader';
import {MainFooter} from 'presentation/components';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';
import {UserManualAlert} from 'presentation/components/UserManualAlert';
import {StyledFooterContainer} from './styles';
import {ServiceCard} from '../../components';
import {useRefundList} from '../../hooks';

const {title, home} = translations['pt-br'].privateFlow.refund;

export function RefundList() {
	const navigate = useNavigate();
	const {state: routeState} = useLocation();
	const {isMobile} = useMediaQueries();
	const {REFUND_LIST} = useRefundList();
	const {isPPOPlan} = useAccountInformation();
	const refundListFiltered = REFUND_LIST.filter(item => item.show);

	const handleBack = useCallback(() => {
		if (routeState && routeState === '/servicos') {
			navigate(routeState);
			return;
		}
		navigate(HomeEnum.HOME_PAGE);
	}, [routeState]);

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				title={title}
				handleBack={handleBack}
				handleClose={handleBack}
				variant="subRoute">
				<Box px={!isMobile ? 4 : 2} pb={2}>
					<Typography variant="h6">{home.subtitle}</Typography>
				</Box>
			</MainHeader>
			<Container sx={{pt: isPPOPlan ? 4 : 0}}>
				{isPPOPlan ? <UserManualAlert type="refund" /> : null}
			<Grid2 spacing={2} pt={isPPOPlan ? 2 : 4} container>
				{refundListFiltered.map(service => (
					<Grid2 size={{md: 6, lg: 6, xs: 12}} key={service.route}>
							<ServiceCard dataTagId={service.dataTagId} {...service} />
					</Grid2>
				))}
			</Grid2>
			</Container>
			<StyledFooterContainer>
				<MainFooter />
			</StyledFooterContainer>
		</PageWrapperLayout>
	);
}
